<template>
  <div class="description-notes">
    <v-dialog
      v-model="isVisible"
      max-width="780"
      transition="dialog-transition"
    >
      <v-card>
        <v-card-title
          class="description-notes__title headline"
          primary-title
        >
          HR NOTES
          <v-btn icon large color="primary" @click="closeModal">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-row>
            <v-col class="py-0 pl-0">
              <v-textarea
                v-model="notes"
                solo
                flat
                hide-details
                label="Notes"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions class="description-notes__actions">
          <v-btn
            color="blue"
            dark
            large
            :loading="isSubmitProcessing"
            @click="submit"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  props: {
    value: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      notes: '',
      featuresList: [],
    };
  },

  computed: {
    ...mapState('hrDeveloper', [
      'developer',
      'isSubmitProcessing',
    ]),

    isVisible: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },

  watch: {
    isVisible() {
      this.notes = this.isVisible ? this.developer.notes : '';
    },
  },

  methods: {
    ...mapActions('hrDeveloper', [
      'updateDeveloper',
    ]),

    closeModal() {
      this.$emit('input', false);
    },

    submit() {
      this.updateDeveloper({ notes: this.notes })
        .then(() => {
          this.closeModal();
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.description-notes {
  &__title {
    display: flex;
    justify-content: space-between;
    font-weight: 600 !important;
    font-size: 22px !important;
  }

  &__actions {
    padding: 0 24px 16px 24px;
    justify-content: flex-end;
  }
}
</style>
